import { atom } from 'recoil';

export const kakaoState = atom({
    key: 'kakaoState', // 고유한 key 값 설정
    default: null,
});
